import { HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, ReplaySubject, BehaviorSubject, Observable } from 'rxjs';
import { LoggedUser } from "../models/assemblea/LoggedUser";
import { SoftwareInfo } from "../models/assemblea/SoftwareInfo";
import { catchError, map, switchMap, filter, take } from 'rxjs/operators';


@Injectable(
    {
        providedIn: 'root'
    }
)
export class IdentityService {
    user: LoggedUser;
  OnLoggedIn: ReplaySubject<LoggedUser> = new ReplaySubject<LoggedUser>(1);
  OnRefreshIn: ReplaySubject<LoggedUser> = new ReplaySubject<LoggedUser>(1);
  OnLoggedOut: ReplaySubject<void> = new ReplaySubject(1);

  OnVerifyVersionRequest: ReplaySubject<SoftwareInfo> = new ReplaySubject<SoftwareInfo>(1);
  OnPageNeedReload: ReplaySubject<void> = new ReplaySubject(1);

  refreshSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public refreshNeeded = false;
  private canRefresh = false;

  public get CanRefresh(): boolean {
    return this.canRefresh;
  }
  public set CanRefresh(can: boolean) {
    this.canRefresh = can;
    this.refreshSubject.next(can);
    if (can && this.refreshNeeded) {
      if (this.isLoggedIn) {
        this.OnVerifyVersionRequest.next(null);
      }
    }
  }

    get isLoggedIn(): boolean {
        return this.user != null;
    }
    
    constructor() {
      this.user = JSON.parse(localStorage.getItem('currentUser'))
        if (this.user)
        this.OnLoggedIn.next(this.user);
    }

  setUser(user: LoggedUser) {
        localStorage.setItem('currentUser', JSON.stringify(user));
      this.user = user;
        this.OnLoggedIn.next(user);
  }
  refreshUser(user: LoggedUser) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.user = user;
    this.OnRefreshIn.next(user);
  }
    removeUser() {
        localStorage.removeItem('currentUser');
        this.user = null;
        this.OnLoggedOut.next();
  }

  
}
